import { Box, Button } from "@chakra-ui/react";
import { useState } from "react";

import { Download } from "lucide-react";
import DownloadReportModal from "./DownloadReportModal";

const Buttons = (): JSX.Element => {
  const [isOpenDownloadReportModal, setIsOpenDownloadReportModal] =
    useState<boolean>(false);

  const onClose = () => {
    setIsOpenDownloadReportModal(false);
  };

  return (
    <>
      <Box display={"flex"} gap={"1.5rem"}>
        <Button size="sm" onClick={() => setIsOpenDownloadReportModal(true)}>
          <Download size={16} />
          Descargar reporte de pago
        </Button>
      </Box>

      <DownloadReportModal open={isOpenDownloadReportModal} onClose={onClose} />
    </>
  );
};

export default Buttons;
